import { render, staticRenderFns } from "./VehicleTypeView.vue?vue&type=template&id=d41d6132&"
import script from "./VehicleTypeView.vue?vue&type=script&lang=js&"
export * from "./VehicleTypeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports